module.exports = __webpack_public_path__ + "img/Recurso 41@300x l.335a118c.png";